import {ToggleButton as ToggleButtonMUI} from '@material-ui/lab';
import {ToggleButtonGroup as ToggleButtonGroupMUI} from '@material-ui/lab';

export const ToggleButtonGroup = (props) => (<ToggleButtonGroupMUI {...props}/>)
export const ToggleButton = (props) => (<ToggleButtonMUI {...props}/>)